import Vue from 'vue'
import List from '../../components/List'
import Empty from '../../components/Empty'

// added to main.js
// import apis from '../../apis/index'
// Vue.use(apis)

Vue.component(List.name, List)
Vue.component(Empty.name, Empty)
